import { SKINS } from "~/contexts/SkinContext/skinConstants.ts";
import type { PresenterDebugSearch } from "~/features/gameSession/components/PresenterDebugView/presenterDebugTypes.ts";
import { parseDebugSessionSearch } from "~/features/gameSession/debugSessionGenerator/debugSessionSearch.ts";

/**
 * Parses the search params of the presenter debug routes.
 *
 * Rule: this file imports types, other search parsers, and constant files with no import. The route config imports
 * it outside the code-split component chunk, so any other import ships in the main bundle.
 */
export const parsePresenterDebugSearch = (search: Record<string, unknown>): PresenterDebugSearch => ({
    ...parseDebugSessionSearch(search),
    players: typeof search.players === "number" ? search.players : undefined,
    view: typeof search.view === "string" ? search.view : undefined,
    skin: SKINS.find((skin) => skin === search.skin),
});
